
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import {
  getFDwhiteNode,
  getAvoidLoginUrl,
  getWhiteSign,
  setOrderNotice
} from "@/api/iousServices";
import { openFDWhitePage, getSessionItem, setSessionItem } from '@/utils/h5ToApp'
import dayjs from "dayjs";
import router from '@/router'

/**
 * nodeID
 * 2 签约华润
 * 4 借款成功
 * 5 借款失败
 */
@Component
export default class ResultPopup extends Vue {
  @Prop({ default: '' }) orderId!: string
  companyId = ''
  mobile = ''
  showResult = false
  noteInfo:{[x:string]:any} = {}
  whiteSignTimeResult = ''
  endSignTimeResult = ''
  isClose = ''
  routeName = '' // 当前弹窗所在路由名称

  @Watch('showResult')
  onShowResultChange() {
    this.changeNativeAreaColor(this.showResult)
  }

  mounted() {
    getSessionItem('closeCache').then(res=>{
      console.log('closeCache=', res);
      if (res === 'success') {
        this.isClose = res
      }
    })
    // this.getNode()
    // this.getSign()
  }

  getNode(vm: any) {
    this.routeName = vm.routeName
    return getFDwhiteNode({orderId: this.orderId}).then((res) =>{
      const { code, data } = res;
      if (code === "000000") {
        this.noteInfo = data[0] ? data[0] : {}
        // this.noteInfo = {
        //   nodeId: '3',
        //   orderMoney: '20000',
        // }
      }
    })
  }

  closePopup() {
    setSessionItem('closeCache', '1')
    this.showResult = false
  }

  confirm() {
    // window.localStorage.setItem('isConfirm','1')
    this.showResult = false
    let data = {
      orderId:this.noteInfo.orderId
    }
    setOrderNotice(data)
  }

  signContract() {
    console.log('this.whiteSignTimeResult',this.whiteSignTimeResult)
    console.log('this.endSignTimeResult',this.endSignTimeResult)
    console.log('flag',this.whiteSignTimeResult < this.endSignTimeResult)
    // 是否签署授权书
    if (window.localStorage.getItem('isSign') == '1' && this.whiteSignTimeResult < this.endSignTimeResult) {
      console.log('进入====1');

      this.fdfreeLogin('4')
    } else {
      window.localStorage.removeItem('isSign')
      console.log('进入====2');
      this.showResult = false
      router.push({
          path: "/iousAuthorize",
          query: {
              webshow: '4'
          },
      });
    }
  }

  // 1还款入口 2授信入口 3借款入口 4全局弹框
  fdfreeLogin(flag = '') {
    let params = {
      companyId: this.companyId,
      webShow: flag
    }
    getAvoidLoginUrl({...params}).then((res) =>{
      const { code, data } = res
      if( code === "000000" ) {
        // 是否签约
        // setSessionItem('signContract', '1')
        this.showResult = false
        let encodeUrl = encodeURI(data.responseData.redirectUrl)
        // 完成授信流程，webShow=1或3替换成2
        if (encodeUrl.indexOf('webShow=1') > -1 || encodeUrl.indexOf('webShow=2') > -1 || encodeUrl.indexOf('webShow=3') > -1 || encodeUrl.indexOf('webShow=4') > -1) {
          encodeUrl.replace(/webShow=[d{1,2,3,4}]/,`webShow=${flag}`)
        }
        let isQuery = encodeUrl.indexOf('?') > -1
        let url = `${encodeUrl}${isQuery? '&' : '?'}userPhone=${this.mobile}`
        openFDWhitePage({url})
        console.log('getAvoidLoginUrl=',url);
      }
    }).catch(() => {
      this.$toast('此产业商城暂未开通白条快付')
    })
  }

  getSign() {
    // 获取授权书记录
    getWhiteSign().then((res =>{
      const { code, data } = res
      if( code === "000000" && data) {
        console.log('data=====',typeof data)
        let firstSignTime = data.whiteSignTime
        firstSignTime = dayjs(firstSignTime).format("YYYY-MM-DD")
        this.endSignTimeResult = dayjs(firstSignTime).add(360, 'day').format("YYYY-MM-DD");
        this.whiteSignTimeResult = dayjs().format("YYYY-MM-DD");
        if (this.whiteSignTimeResult < this.endSignTimeResult) window.localStorage.setItem('isSign','1')
      }
    }))
  }

  changeNativeAreaColor (isShow: boolean) {
    const normalColor = this.routeName === 'ShopMallOrder' ? 'DCE9F9' : 'FFFFFF'
    const params = {
      statusBarColor: isShow ? '000000' : normalColor,  // 状态栏颜色
      bottomColor: isShow ? '000000' : 'FFFFFF', // 底部安全区颜色
      alpha: isShow ? 0.7 : 1
    }
    this.$bridge.callHandler('changeNativeAreaColor', params, (res) => {
    })
  }
}
